<div class="relative custom-dialog">
  <!-- Title -->
  <div class="custom-dialog-header">
    <h3>{{ dialogTitle }}</h3>
    <div class="custom-dialog-header-right-side">
      <ng-content select="[y42DialogHeader]"></ng-content>
      <div class="header-actions">
        <button
          *ngIf="allowFullscreen"
          mat-icon-button
          (click)="toggleFullscreen()"
          class="icon-button-fullscreen custom-button-icon-small"
          type="button"
        >
          <y42-icon
            [icon]="
              state.fullscreen
                ? 'arrow-down-left-and-arrow-up-right-to-center'
                : 'arrow-up-right-and-arrow-down-left-from-center'
            "
          ></y42-icon>
        </button>
        <button
          *ngIf="closeable"
          mat-icon-button
          type="button"
          data-test="dialog-close-icon-button"
          class="icon-button-close"
          (click)="cancelClicked()"
        >
          <y42-icon [icon]="'times'"></y42-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Body -->
  <div class="custom-dialog-body" [ngClass]="noBodyPadding ? 'custom-dialog-body-no-padding' : ''">
    <ng-content select="[y42DialogBody]"></ng-content>
  </div>

  <!-- Actions -->
  <div class="custom-dialog-footer">
    <div class="dialog-footer">
      <ng-content select="[y42DialogFooter]"></ng-content>
    </div>

    <div class="dialog-actions">
      <y42-button data-test="dialog-cancel-button" (click)="cancelClicked()">
        {{ cancelLabel || (confirmLabel ? 'Cancel' : 'Close') }}
      </y42-button>

      <ng-content select="[y42DialogAdditionalActions]"></ng-content>

      <y42-button
        *ngIf="confirmLabel"
        type="submit"
        [color]="confirmColor ?? 'primary'"
        [disabled]="confirmDisabled"
        [pending]="confirmPending"
        id="dialog-confirm-button"
        data-test="dialog-confirm-button"
        class="confirm-button"
        (click)="confirmed()"
      >
        <ng-container *ngIf="state.confirmLabelTemplate; else defaultConfirmLabel">
          <ng-container *ngTemplateOutlet="state.confirmLabelTemplate"></ng-container>
        </ng-container>

        <ng-template #defaultConfirmLabel>
          {{ confirmLabel }}
        </ng-template>

        <y42-keyboard-shortcut *ngIf="!disableCmdEnter" [shortcut]="'CmdEnter'"></y42-keyboard-shortcut>
      </y42-button>
    </div>
  </div>
</div>
